module.exports = __webpack_public_path__ + "static/Section_2-1528bc219565765dc8afc55ee6abff22.png";